import React, { useState } from 'react';
import { Typography } from '@material-ui/core';
import { PageTemplate, PageTemplateCardOver, PageTemplateHeader } from '@sierralabs/core-ui';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
import { useSiteContext } from '../../SiteContext';
import { SiteComponent } from '../SiteComponentPlugin';
export const SiteCardOverPage = props => {
    const { children } = props;
    const component = useSubscribeComponentChanges(SiteCardOverPagePlugin, props);
    const { editing } = useSiteContext();
    const [openDialog, setOpenDialog] = useState(false);
    // console.log('route', path || component?.props?.path, component);
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteCardOverPagePlugin }, props),
        React.createElement(PageTemplate, null,
            React.createElement(PageTemplateHeader, null,
                React.createElement(Typography, { variant: 'h2' }, "Placeholder")),
            React.createElement(PageTemplateCardOver, null))));
};
export const SiteCardOverPageConfigurator = ({ component }) => {
    var _a;
    const { update, updateSlot } = useConfigComponent(component);
    const slotComponent = (_a = component.children) === null || _a === void 0 ? void 0 : _a.find(c => c.slot === 'route');
    return (React.createElement(React.Fragment, null));
};
export const SiteCardOverPagePlugin = {
    name: 'Site Card Over Page',
    type: 'site-card-over-page',
    component: SiteCardOverPage,
    configurator: SiteCardOverPageConfigurator
};
//# sourceMappingURL=SiteCardOverPagePlugin.js.map